import { css } from 'styled-components';
export default css(["padding:0;display:none;", ";", ";"], function (props) {
  return props.isSelected ? "\n    display: block;\n  " : '';
}, function (props) {
  return props.inheritedStyles ? props.inheritedStyles : '';
});